import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import '../css/CursorFollower.css';

const CursorFollower = () => {
    const mainCursor = useRef(null);
    const secondaryCursor = useRef(null);

    useEffect(() => {
        // Detect touch capability or small screen
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        const isMobile = window.innerWidth < 1024;

        if (isMobile || isTouchDevice) return;

        const onMouseMove = (e) => {
            const { clientX, clientY } = e;
            
            // Inner dot (Fast)
            gsap.to(mainCursor.current, {
                x: clientX,
                y: clientY,
                xPercent: -50, // Ensures perfect center alignment
                yPercent: -50,
                duration: 0.1,
                ease: "none"
            });

            // Outer circle (Slightly delayed for 'liquid' feel)
            gsap.to(secondaryCursor.current, {
                x: clientX,
                y: clientY,
                xPercent: -50,
                yPercent: -50,
                duration: 0.5,
                ease: "power2.out"
            });
        };

        window.addEventListener('mousemove', onMouseMove);
        return () => window.removeEventListener('mousemove', onMouseMove);
    }, []);

    // Double-check for mobile to prevent component mounting
    if (window.innerWidth < 1024) return null;

    return (
        <>
            <div className="main-cursor" ref={mainCursor}></div>
            <div className="secondary-cursor" ref={secondaryCursor}></div>
        </>
    );
};

export default CursorFollower;

